import { TenantEntity } from '../TenantEntity'

export class OtherCharge extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }

  get chargeItem() {
    return this._data.chargeItem
  }
  set chargeItem(chargeItem) {
    this._data.chargeItem = chargeItem
  }
  get measure() {
    return this._data.measure
  }
  set measure(measure) {
    this._data.measure = measure
  }
  get unitRate() {
    return this._data.unitRate
  }
  set unitRate(unitRate) {
    this._data.unitRate = unitRate
  }
  get amount() {
    return this._data.amount
  }
  set amount(amount) {
    this._data.amount = amount
  }
  get remark() {
    return this._data.remark
  }
  set remark(remark) {
    this._data.remark = remark
  }
  get minAmount() {
    return this._data.minAmount
  }
  set minAmount(minAmount) {
    this._data.minAmount = minAmount
  }
  get chargeId() {
    return this._data.chargeId
  }
  set chargeId(chargeId) {
    this._data.chargeId = chargeId
  }
  get airCargoDocUuid() {
    return this._data.airCargoDocUuid
  }
  set airCargoDocUuid(airCargoDocUuid) {
    this._data.airCargoDocUuid = airCargoDocUuid
  }
}
